import { useLayoutEffect } from 'react'
import { createLenis, destroyLenis } from '../lib/lenis'

const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

// Mounted once at the app root. Smooth-scroll only makes sense outside retro
// mode and reduced-motion  both already gate every other scroll animation
// on the site (useScrollReveal, useScrollZoom), so Lenis follows the same
// rule instead of introducing a third source of truth.
export const useLenisSetup = (retroMode) => {
  useLayoutEffect(() => {
    if (retroMode || prefersReducedMotion()) {
      destroyLenis()
      return undefined
    }

    createLenis()

    return () => destroyLenis()
  }, [retroMode])
}
